import { Box, Grid, Typography } from "@mui/material";
import React from "react";
import styles from "../../assets/styles/loan.module.css";
import Strings from "../../utils/stringUtil";
import { whyLoanOptions } from "../../utils/businessLoanUtil";
import AppIcons from "../../utils/appIcons";
import { isMobile, isTablet } from "../../utils/responsiveUtil";

function WhyLoan() {
  return (
    <Box className={`container`}>
      <Box
        style={{ transform: isMobile ? "scale(1)" : "scale(0.92)" }}
        pt={isMobile ? "80px" : "40px"}
        pb={"46px"}
      >
        <Box className={styles.flexColumnCenter}>
          <Typography className={styles.loanTitle}>
            {Strings.whyLoanForWomenTitle}
          </Typography>
          <Typography className={styles.loanDescription}>
            {Strings.whyLoanForWomenSubTitle}
          </Typography>
        </Box>

        {isMobile ? (
          <Box className={styles.whyLoanMobileBox} mt={5}>
            {whyLoanOptions.map((option, index) => (
              <OptionCard option={option} key={index} />
            ))}
          </Box>
        ) : (
          <Grid
            container
            mt="10px"
            spacing={isTablet ? 3 : 6}
            position={"relative"}
          >
            <img
              src={AppIcons.imgWhyLoan}
              width={167}
              className={styles.whyLoanBadge}
            />
            {whyLoanOptions.map((option, index) => (
              <Grid item xs={12} sm={6} key={option.title}>
                <OptionCard option={option} key={index} />
              </Grid>
            ))}
          </Grid>
        )}
      </Box>
    </Box>
  );
}

function OptionCard({ option }) {
  return (
    <Box
      className={styles.whyLoanOptionCard}
      height={isMobile ? "auto" : "100%"}
      minWidth={isMobile ? "90%" : "100%"}
    >
      <img src={option.icon} alt={option.title} width={20} />
      <Typography className={styles.whyLoanOptionCardTitle}>
        {option.title}
      </Typography>
      <Typography className={styles.whyLoanOptionCardDesc}>
        {option.desc}
      </Typography>
    </Box>
  );
}

export default WhyLoan;
